import {
  Avatar,
  Box,
  IconButton,
  makeStyles,
  Typography,
} from "@material-ui/core";
import { HighlightOff } from "@material-ui/icons";
import React from "react";
import { User } from "../../../domain/User";
import { useAuth } from "@ofqual/portal-core/core/hooks/useAuth";
import { UserType } from "../../../redux/types";
import { authSelector } from "../../../redux/selectors";

const useStyles = makeStyles((theme) => ({
  box: {},
  avatar: {
    height: 80,
    width: 80,
    alignSelf: "center",
    margin: 10,
    fontSize: "2em",
  },
  inner: {
    width: 170,
    height: 170,
    margin: 20,
    padding: 20,
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    position: "relative",
  },
  delete: {
    position: "absolute",
    background: "none",
    right: 20,
    top: 3,
    backgroundColor: "transparent",
  },
  deleteIcon: {
    color: theme.palette.grey[600],
  },
}));

export type PermissionedUserProps = {
  user: User;
  onDelete?: (userId: string) => void;
  isOwner?: boolean;
  allowReassignment: boolean;
};

export const PermissionedUser: React.FC<PermissionedUserProps> = ({
  user,
  isOwner,
  onDelete,
  allowReassignment,
}) => {
  const { userType, upn } = useAuth(authSelector);
  const classes = useStyles();

  const firstInitial = user.firstName[0];
  const secondInitial = user.surname[0];

  const isAuthedUser = user.upn === upn;

  return (
    <Box className={classes.box} data-test="staff-permission-chip">
      <div className={classes.inner}>
        <Avatar className={classes.avatar}>
          {firstInitial}
          {secondInitial}
        </Avatar>
        {!isOwner &&
          userType === UserType.AO &&
          allowReassignment &&
          !isAuthedUser && (
            <IconButton
              className={classes.delete}
              onClick={() => onDelete && onDelete(user.id)}
              data-test="staff-permissions-removal"
            >
              <HighlightOff className={classes.deleteIcon}></HighlightOff>
            </IconButton>
          )}
        <Typography variant="subtitle1">
          {user?.fullName} {isOwner && "(owner)"}
        </Typography>
      </div>
    </Box>
  );
};
